import { Component, DestroyRef, HostBinding, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SafeUrl } from '@angular/platform-browser';

import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { RacingOptionMarketTypes, WinGameFixture } from '@frontend/sports/racing/feature/models';
import { Observable, of } from 'rxjs';

import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { RacingService } from '../../services/racing-service';

@Component({
    selector: 'ms-horses-specials',
    templateUrl: './horses-specials.component.html',
    standalone: false,
})
export class HorsesSpecialsComponent implements OnInit, OnChanges {
    @HostBinding('class') className = 'option-group__option';
    @Input() optionGroups: EventOptionGroup[];
    @Input() event: WinGameFixture;
    @Input() trackingSource: string;
    @Input() trackingModuleType: string;
    @Input() trackingOptions: { [key: string]: string };
    @Input() isGreyhounds = false;
    @Input() selectedMarketId: number;
    trapImages$: Observable<{ [key: string]: SafeUrl }>;

    attributeValue?: string;
    showAttributeValue: boolean;
    valuesForToggle: number[] = [];
    isFirstLoad = true;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public siteCore: Sitecore,
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
        public racingService: RacingService,
    ) {}

    ngOnInit(): void {
        if (this.isGreyhounds) {
            this.racingService.getTraps$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((image) => (this.trapImages$ = of(image)));
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedMarketId) {
            this.isFirstLoad = true;
            this.valuesForToggle = [];
        }
        if (
            this.isGreyhounds &&
            this.checkIfSpecialMarket(this.racingService.getMarketOptionGroup(this.optionGroups, RacingOptionMarketTypes.FreeFormed)!) &&
            this.isFirstLoad
        ) {
            this.optionGroups = this.optionGroups.reverse();
            this.isFirstLoad = false;
        }
    }

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }

    trackOptionGroup(index: number, optionGroup: EventOptionGroup): number {
        return Number(optionGroup.id);
    }

    getAvailableTrapImages(option: EventOption): number[] | undefined {
        return this.racingService.getAvailableTrapImages(option, this.event);
    }

    checkIfSpecialMarket(optionGroup: EventOptionGroup): boolean | undefined {
        if (optionGroup && optionGroup.options.length) {
            return optionGroup.options[0].optionTypes ? !(optionGroup.options[0].optionTypes.length > 0) : undefined;
        }

        return undefined;
    }

    toggleHeader(index: number) {
        this.isFirstLoad = false;
        if (this.valuesForToggle.includes(index)) {
            this.valuesForToggle = this.valuesForToggle.filter((x) => x !== index);
        } else {
            this.valuesForToggle.push(index);
        }
    }

    checkIfOptionActive(option: EventOption): boolean {
        return this.horsesFixturePricingHelper.isV3WinOptionAvailable(option);
    }

    checkIfWinningDistance(optionGroup: EventOptionGroup): boolean {
        return !!this.racingService.getMarketOptionGroup([optionGroup], RacingOptionMarketTypes.WinnerByHowFar);
    }
}
